<div class="d-flex bg-white" >  
  <div class="d-flex p-2">
    <img [src]="'assets/img/entregas_' + icone + '.svg'">
  </div>
  <div class="pt-2 ms-3">
    <p class="titulo">{{ titulo }}</p>
    <p class="font-qtd"> {{ quantidade }} </p>
  </div>
</div>
